import React from 'react';
import PropTypes from 'prop-types';
import Icon from '@components/base_svg-icon/component';
import { TitleAndSubtitle, ProductImage } from 'audamatic-ui';
import PriceBlock from '@components/base_price-block/component';
import { formatDate } from '@utils';
import Text from '@text';

import './styles.scss';

const HistoryModal = (props) => {
  const { product, store, openProducts = [], deliveredProducts = [] } = props;

  return (
    <div className="history-sidepanel">
      <section className="product">
        <div className="product-wrap">
          <ProductImage product={product} maxHeight={92} />
        </div>
        <TitleAndSubtitle title={product.name} subtitle={product.tagline}/>
        <PriceBlock product={product} priceToPay={product.price.value} store={store} size="small" onePrice/>
      </section>
      {!!openProducts.length && (
        <section>
          <h4><Text>pdp.orderhistory.open-orders</Text></h4>
          {openProducts.map((order, i) => (
            <div className="order" key={`open-${i}`}>
              <div className="order-date">{formatDate(order.productDate)}</div>
              <div className="order-quantity">{order.productQty} <Text>pdp.orderhistory.items</Text></div>
            </div>
          ))}
          <a href={`/mijn-account/orders?search=${product.ean || product.sku}`} className="link-decorated"> <Icon name="ico-arrow-circle-right" size={150} /> <Text>pdp.orderhistory.go-to-orders</Text></a>
        </section>
      )}
      {!!deliveredProducts.length && (
        <section>
          <h4><Text>pdp.orderhistory.delivered-orders</Text></h4>
          {deliveredProducts.map((order, i) => (
            <div className="order" key={`delivered-${i}`}>
              <div className="order-date">{formatDate(order.productDate)}</div>
              <div className="order-quantity">{order.productQty} <Text>pdp.orderhistory.items</Text></div>
            </div>
          ))}
          <a href={`/mijn-account/leveringen?search=${product.ean || product.sku}`} className="link-decorated"> <Icon name="ico-arrow-circle-right" size={150} /> <Text>pdp.orderhistory.go-to-deliveries</Text></a>
        </section>
      )}
    </div>
  );
};

HistoryModal.propTypes = {
  product: PropTypes.object,
  store: PropTypes.object,
  deliveredProducts: PropTypes.array,
  openProducts: PropTypes.array,
};

export default HistoryModal;
